<template>
  <el-dialog
    width="40%"
    :visible.sync="updatePasswordVisi"
    :before-close="close"
    :close-on-click-modal="false"
  >
    <el-row type="flex" justify="center">
      <el-col :span="14">
        <el-form ref="form" :rules="rules" :model="form">
          <el-form-item :label="$t('profile.loginName')">
            <el-input v-model="userInfo.loginName" disabled />
          </el-form-item>
          <el-form-item :label="$t('profile.oldPassword')" prop="oldPassword">
            <el-input v-model="form.oldPassword" clearable type="password" :placeholder="$t('profile.oldPasswordPlaceholder')" />
          </el-form-item>
          <el-form-item :label="$t('profile.newPassword')" prop="newPassword">
            <el-input v-model="form.newPassword" clearable type="password" :placeholder="$t('profile.newPasswordPlaceholder')" />
          </el-form-item>
          <el-form-item :label="$t('profile.confirmPassword')" prop="confirmPassword">
            <el-input
              v-model="form.confirmPassword"
              clearable
              type="password"
              placeholder="请输入当前密码"
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.close') }}</el-button>
      <el-button type="primary" :loading="submitLoading" @click="formOnSubmit('form')">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { validateConfirmPassword } from '@/utils/formValidate'
import { updatePassword } from '@/api/user'
export default {
  data() {
    return {
      form: {},
      rules: {
        oldPassword: [{ required: true, message: this.$t('profile.oldPasswordPlaceholder'), trigger: 'blur' }],
        newPassword: [{ required: true, message: this.$t('profile.newPasswordPlaceholder'), trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: this.$t('profile.newPasswordPlaceholder'), trigger: 'blur' },
          { validator: (rule, value, callback) => { validateConfirmPassword(rule, value, callback, this.form.newPassword) }, trigger: 'blur' }
        ]
      },
      submitLoading: false
    }
  },
  computed: {
    ...mapState({
      updatePasswordVisi: state => state.user.updatePasswordVisi,
      userInfo: state => state.user.userInfo
    })
  },
  watch: {
    updatePasswordVisi(val) {
      if (val) {
        this.form.tenementUserId = this.$store.state.user.userInfo.tenementUserId
      }
    }
  },
  methods: {
    close() {
      this.$store.dispatch('user/setUpdatePasswordVisi', false)
    },
    formOnSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onSubmit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmit() {
      this.submitLoading = true
      updatePassword(this.form).then(res => {
        this.$message.success(res.message)
        this.close()
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
